<template>
  <UiLink class="li" v-bind="item.path" :title="item.title">
    <UiBaseIcon :icon-name="item.icon" width="20" height="20" color="black" />

    <Counter :count="item.count" />
  </UiLink>
</template>

<script>
import UiLink from '@/components/UiLink.vue'
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

import Counter from './Counter.vue'

export default {
  components: { UiBaseIcon, UiLink, Counter },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
.li {
  position: relative;

  @include square($navbarWidth);
  @include createFlex(flexbox, nowrap, row, center, center, center);

  &:hover {
    cursor: pointer;
    background: lighten($color-gray-50, 10%);
  }
}

.link-active-class {
  background: $color-gray-50;

  &:hover {
    background: $color-gray-50;
  }
}
</style>
